/* eslint-disable max-len, no-param-reassign */
import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import frLocale from '@fullcalendar/core/locales/fr';

function initCalendar(calendarId, config) {
    const calendarEl = document.getElementById(calendarId);
    const dateStart = document.querySelector('.js-form-item-event-date-min input').value || '';
    const dateEnd = document.querySelector('.js-form-item-event-date-max input').value || '';

    const calendar = new Calendar(calendarEl, config);
    calendar.render();
    if (dateStart && dateEnd) {
        calendar.select(dateStart, dateEnd);
    }
    return calendar;
}

if (document.querySelector('.training-events-page-content')) {
    const lang = document.querySelector('html').getAttribute('lang');
    const calendarConfig = {
        plugins: [dayGridPlugin, interactionPlugin],
        locales: [frLocale],
        locale: lang,
        longPressDelay: 300,
        aspectRatio: 1,
        initialView: 'dayGridMonth',
        headerToolbar: {
            left: 'title',
            right: 'prev next',
        },
        dayHeaderFormat: {
            weekday: 'narrow',
        },
        selectable: true,
        select(info) {
            if (info.startStr && info.endStr) {
                document.querySelector('.js-form-item-event-date-min input').value = info.startStr;
                document.querySelector('.js-form-item-event-date-max input').value = info.endStr;
                if (info.jsEvent !== null) {
                    document.querySelector('#views-exposed-form-events-event-dates .js-form-submit').click();
                }
            }
        },
        unselectAuto: false,
        events: lang === 'fr' ? '/api/events/dates' : `/${lang}/api/events/dates`,
        validRange(nowDate) {
            const firstOfMonth = new Date(nowDate.getFullYear(), nowDate.getMonth(), 1);
            return {
                start: firstOfMonth,
            };
        },
    };

    // Observer pour regénérer les calendriers après un submit du form
    const observerConfig = {
        childList: true,
        attributes: true,
        subtree: true,
        attributeOldValue: true,
    };

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'data-once') {
                if (mutation.oldValue === 'exposed-form form-updated') {
                    window.calendarObj.destroy();
                    window.calendarObj = initCalendar('calendar', calendarConfig);
                    window.panelCalendarObj.destroy();
                    window.panelCalendarObj = initCalendar('panel-calendar', calendarConfig);
                }
            }
        });
    });

    const tabObserverConfig = {
        childList: false,
        attributes: true,
        subtree: false,
        attributeOldValue: true,
    };

    const tabObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
                if (mutation.oldValue === 'true') {
                    window.calendarObj.updateSize();
                }
            }
        });
    });

    document.addEventListener('DOMContentLoaded', () => {
        window.calendarObj = initCalendar('calendar', calendarConfig);
        window.panelCalendarObj = initCalendar('panel-calendar', calendarConfig);
        tabObserver.observe(document.querySelector('#upcoming-events'), tabObserverConfig);
    });
    [...document.querySelectorAll('.upcoming-events-wrapper .views-element-container')].forEach((item) => {
        observer.observe(item, observerConfig);
    });
}
